import { Location } from '../models/iLocation';

export const locations: Location[] = [
  // {
  //   name: 'Nashoba Regional School District',
  // },
  // {
  //   name: 'Assabet Valley Collaborative',
  // },
  // {
  //   name: 'Wilmington Public Schools',
  // },
  // {
  //   name: 'Guild for Human Services',
  // },
  {
    name: 'Walpole Public Schools',
  },
  {
    name: 'Randolph Public Schools'
  },

  // {
  //   name: 'Anchor Academy',
  // },
  {
    name: 'Whitney Academy',
  },
  // {
  //   name: 'Administrative Assistant',
  // },
  // {
  //   name: 'Associate',
  // },
  // {
  //   name: 'Evaluation SLP Services',
  // },
  {
    name: 'Somerville Public Schools'
  },
  // {
  //   name: 'Norwood Public Schools',
  // },
  // {
  //   name: 'Tewksbury Public School',
  // },
  // {
  //   name: 'Woodstock Academy',
  // },
  // {
  //   name: 'Bay Cove Academy',
  // },
  // {
  //   name: 'CASE Collaborative'
  // },
  {
    name: 'Pioneer Charter School of Science'
  },
  {
    name: 'Methuen Public Schools'
  },
  { name: 'Wakefield Public Schools' },
  { name: 'Winthrop Public Schools' },
  // { name: 'Dudley Public Schools' },
  // { name: 'Duxbury Public Schools' },
  // { name: 'Sharon Public School' }
];
